import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	// --- Prompt (Top Suggestion) ---
	promptTitle: {
		id: 'experiment-loom-recording-suggestions-on-confluence-pages-using-llms.prompt.heading.non-final',
		defaultMessage: 'Give readers a summary video',
		description: 'Headline text in the Loom prompt encouraging users to add a summary video',
	},

	// --- Buttons ---
	viewScriptButton: {
		id: 'experiment-loom-recording-suggestions-on-confluence-pages-using-llms.button.see-script.non-final',
		defaultMessage: 'See script',
		description: 'Label for the button to show the auto-generated Loom script',
	},
	recordVideoButton: {
		id: 'experiment-loom-recording-suggestions-on-confluence-pages-using-llms.button.record-video.non-final',
		defaultMessage: 'Record video',
		description: 'Label for the button that starts the Loom video recording',
	},
	okButton: {
		id: 'experiment-loom-recording-suggestions-on-confluence-pages-using-llms.button.ok.non-final',
		defaultMessage: 'Ok',
		description: 'Label for the OK button in the onboarding spotlight',
	},

	// --- AI Label ---
	aiBadgeText: {
		id: 'experiment-loom-recording-suggestions-on-confluence-pages-using-llms.label.powered-by-ai.non-final',
		defaultMessage: 'Powered by AI',
		description: 'Inline label that indicates the feature is powered by Atlassian Intelligence',
	},

	// --- Spotlight (User Guidance Bubble) ---
	spotlightTitle: {
		id: 'experiment-loom-recording-suggestions-on-confluence-pages-using-llms.spotlight.title.non-final',
		defaultMessage: 'Record a video anytime',
		description: 'Title text shown in the Loom onboarding spotlight',
	},
	spotlightDescription: {
		id: 'experiment-loom-recording-suggestions-on-confluence-pages-using-llms.spotlight.description.non-final',
		defaultMessage: 'Easily record and add a Loom video to your page whenever you want.',
		description: 'Body text in the Loom onboarding spotlight that explains usage',
	},

	// --- Popup Card (Script Suggestion Dialog) ---
	popupTitle: {
		id: 'experiment-loom-recording-suggestions-on-confluence-pages-using-llms.popup.title.non-final',
		defaultMessage: 'Record a Loom video',
		description: 'Title of the popup card prompting the user to add a Loom video',
	},
	popupPrimaryMessage: {
		id: 'experiment-loom-recording-suggestions-on-confluence-pages-using-llms.popup.message.main.non-final',
		defaultMessage: 'Explain your key points for your readers.',
		description: 'Main message in the popup card explaining the benefit of adding a video',
	},
	popupContextNote: {
		id: 'experiment-loom-recording-suggestions-on-confluence-pages-using-llms.popup.message.context.non-final',
		defaultMessage: 'This page contains complex content',
		description: 'Secondary note in the popup indicating the page is complex',
	},
	loonScriptValuePopupTriggerLabel: {
		id: 'experiment-loom-recording-suggestions-on-confluence-pages-using-llms.benefit.popup.trigger-label.non-final',
		defaultMessage: 'View script value',
		description: 'Label for the icon button that opens the popup to view the Loom script value',
	},

	// --- Loom Script ---
	loomScriptTitle: {
		id: 'experiment-loom-recording-suggestions-on-confluence-pages-using-llms.loom-script.title.non-final',
		defaultMessage: 'Loom video script',
		description: 'Title for the auto-generated Loom script section',
	},
	loomScriptFooter: {
		id: 'experiment-loom-recording-suggestions-on-confluence-pages-using-llms.loom-script.footer.non-final',
		defaultMessage: 'Content quality may vary.',
		description: 'Footer text in the Loom script panel indicating AI-generated content quality',
	},
	loomScriptTime: {
		id: 'experiment-loom-recording-suggestions-on-confluence-pages-using-llms.loom-script.time.non-final',
		defaultMessage: '{time} min video estimate',
		description: 'Estimated video length based on script content, e.g., "2 min video estimate"',
	},
	loomScriptExpandSectionTitle: {
		id: 'experiment-loom-recording-suggestions-on-confluence-pages-using-llms.loom-script.expand-section-title.non-final',
		defaultMessage: 'Why record a video for this page?',
		description: 'Title for the section explaining the benefit of recording a video for the page',
	},
	loomScriptNeedHelpSectionTitle: {
		id: 'experiment-loom-recording-suggestions-on-confluence-pages-using-llms.loom-script.need-help-title.non-final',
		defaultMessage: 'Need help getting started?',
		description:
			'Title for the section offering guidance or support to help the user begin recording a video',
	},
	loomScriptWatchDemo: {
		id: 'experiment-loom-recording-suggestions-on-confluence-pages-using-llms.loom-script.watch-demo.non-final',
		defaultMessage: 'Watch a 2 minute demo',
		description:
			'Call to action encouraging users to watch a short demo video showing how to record a Loom video for the page',
	},
	loomScriptCopy: {
		id: 'experiment-loom-recording-suggestions-on-confluence-pages-using-llms.loom-script.copy.non-final',
		defaultMessage: 'Copy',
		description: 'Label for the copy button before the user has copied the script',
	},
	loomScriptCopied: {
		id: 'experiment-loom-recording-suggestions-on-confluence-pages-using-llms.loom-script.copied.non-final',
		defaultMessage: 'Copied!',
		description: 'Label for the copy button after the script has been successfully copied',
	},
	loomScriptCopyFailed: {
		id: 'experiment-loom-recording-suggestions-on-confluence-pages-using-llms.loom-script.copy-failed.non-final',
		defaultMessage: 'Copy failed',
		description: 'Label for the copy button when clipboard copy fails',
	},
	loomScriptExpandSectionLabel: {
		id: 'experiment-loom-recording-suggestions-on-confluence-pages-using-llms.loom-script.expand-section-label.non-final',
		defaultMessage: 'Expand section',
		description: 'Label for the button to expand the Loom script section',
	},
	loomScriptCollapseSectionLabel: {
		id: 'experiment-loom-recording-suggestions-on-confluence-pages-using-llms.loom-script.collapse-section-label.non-final',
		defaultMessage: 'Collapse section',
		description: 'Label for the button to collapse the Loom script section',
	},
});
